module.exports = __webpack_public_path__ + "static/07-1cd11e32db367a49a115dfe900e260b6.jpg";